import { Component } from "@angular/core";
import {
  NavController,
  NavParams,
  LoadingController,
  Loading,
} from "ionic-angular";
import * as Enumerable from "linq";
import { NavEntity } from "../../models";
import { StarmsClientProvider } from "../../providers/starms-client/starms-client";
import { forkJoin } from "rxjs/observable/forkJoin";
import { ApplicationApiProvider } from "../../providers/application-api/application-api";
import { Subscription } from "rxjs";
import { DemoProvider } from "../../providers/demo/demo";
import { isTrueProperty } from "ionic-angular/umd/util/util";

@Component({
  selector: "kpi-explorer-page",
  templateUrl: "kpi-explorer.html",
})
export class KpiExplorerPage {
  nav: NavEntity;
  selectedKpiPage: string;
  timeRange: any;
  chartDataSource: any;
  loader: Loading;
  availableData = true;
  time: any;
  subscription = new Subscription();
  hasPowerGenerated = false;
  isIst = false;
  ready = false;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    private starms: StarmsClientProvider,
    private appApi: ApplicationApiProvider,
    private demo: DemoProvider
  ) {
    this.isIst = this.navParams.get("isIst");
  }

  ionViewDidLoad() {
    this.time = this.navParams.get("time");
    if (this.navParams.get("kpi") === "power") {
      this.hasPowerGenerated = true;
      this.selectedKpiPage = "PwrGen";
    } else {
      this.selectedKpiPage = this.navParams.get("kpi");
    }
    this.getChartData();
  }

  getChartData() {
    let self = this;
    this.loader = this.loadingCtrl.create({
      content: "Please wait",
      enableBackdropDismiss: true,
    });
    this.loader.present();
    this.availableData = false;
    this.ready = false;
    this.subscription = forkJoin(
      this.starms.get(
        [
          "kpis",
          this.navParams.get("entity").getType() + "s",
          this.navParams.get("entity").getId(),
          "daily",
        ],
        {
          from: this.time.from,
          to: this.time.to,
          kpitype: this.selectedKpiPage,
        }
      ),
      this.starms.get(
        [
          "kpis",
          this.navParams.get("entity").getType() + "s",
          this.navParams.get("entity").getId(),
          "daily",
        ],
        {
          from: this.time.prevFrom,
          to: this.time.prevTo,
          kpitype: this.selectedKpiPage,
        }
      )
    ).subscribe(
      ([result, previous]) => {
        if (result.length === 0) {
          this.ready = true;
          this.availableData = false;
          this.loader.dismiss();
        } else {
          this.availableData = true;
          // Create the char data source used by the highcharts object
          let chartDataSource: any = {};
          chartDataSource.kpi = result[0].name;
          chartDataSource.type = "column";
          chartDataSource.series = [];
          chartDataSource.avgVal = -1;
          let dateArray = Enumerable.from(result)
            .select(function (x) {
              return x["siteDate"];
            })
            .distinct()
            .toArray();
          chartDataSource.categories = Enumerable.from(dateArray)
            .orderBy((x) => x)
            .toArray();
          let serie = { name: "Current period", color: "#4D217A", data: [] };

          // tslint:disable-next-line:curly
          for (let k in dateArray)
            serie.data.push(
              Enumerable.from(result)
                .where(function (x) {
                  return x["siteDate"] === dateArray[k];
                })
                .average(function (x) {
                  if (self.demo.demoMode) {
                    if (self.selectedKpiPage === "sh") {
                      return x.value;
                    } else {
                      return (x.value / 24) * 100;
                    }
                  } else {
                    if (
                      self.selectedKpiPage === "sh" ||
                      self.selectedKpiPage === "rf"
                    ) {
                      return x.value;
                    } else {
                      return (x.value / 24) * 100;
                    }
                  }
                })
            );

          chartDataSource.series.push(serie);
          if (previous.length === 0) {
          } else {
            chartDataSource.series.push({
              name: "Previous period average",
              color: "#E2D000",
              data: [],
            });
            if (self.demo.demoMode) {
              if (self.selectedKpiPage === "sh") {
                chartDataSource.avgVal = Enumerable.from(previous).average(
                  (x) => x["value"]
                );
              } else {
                chartDataSource.avgVal =
                  (Enumerable.from(previous).average((x) => x["value"]) / 24) *
                  100;
              }
            } else {
              if (
                self.selectedKpiPage === "sh" ||
                self.selectedKpiPage === "rf"
              ) {
                chartDataSource.avgVal = Enumerable.from(previous).average(
                  (x) => x["value"]
                );
              } else {
                chartDataSource.avgVal =
                  (Enumerable.from(previous).average((x) => x["value"]) / 24) *
                  100;
              }
            }
          }
          this.ready = true;
          this.loader.dismiss();
          this.chartDataSource = chartDataSource;
        }
      },
      () => {
        this.ready = true;
        this.appApi.showToast("Error while obtaining kpi data");
        this.loader.dismiss();
      }
    );
  }

  kpiPageChanged(event?: any): void {
    this.subscription.unsubscribe();
    this.chartDataSource = [];
    this.getChartData();
  }

  close(): void {
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/kpi-explorer/kpi-explorer.ts